import waseminari from "../assets/waseminari.png";
import visigalogo from "../assets/visigalogo.png";
import hailmary from "../assets/hailmary.png";
import jesus from "../assets/jesus.png";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";

const OlevelAdmission = () => {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-6 lg:p-10 bg-white dark:bg-gray-900">

            {/* Left Section - Logo */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                    {t("schoolName")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
                        {t("schoolSub")}
                    </span>
                </h1>
                <img
                    src={visigalogo}
                    alt="Visiga Seminary Logo"
                    className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
                />
            </div>

            {/* Center Section - Main Content */}
            <div className="lg:col-span-6 text-gray-800 dark:text-gray-200">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
                    {t("admission.title")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        {t("admission.subtitle")}
                    </span>
                </h2>

                <ul className="list-disc pl-6 space-y-3 text-sm">
                    <li>{t("admission.c1")}</li>
                    <li>{t("admission.c2")}</li>
                    <li>
                        {t("admission.c3")}
                        <ul className="list-disc pl-6 mt-2 space-y-1">

                            <li>{t("admission.exam3")}</li>
                        </ul>
                    </li>
                    <li>{t("admission.c4")}</li>
                </ul>

                <h2 className="mt-8 text-2xl font-semibold text-gray-900 dark:text-white">
                    {t("admission.formsTitle")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        {t("admission.formsSubtitle")}
                    </span>
                </h2>

                <p className="mt-4 text-sm">{t("admission.formsInstructions")}</p>

                <p className="mt-4 text-sm">{t("admission.formsAvailability")}</p>
                <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
                    <li>{t("admission.place1")}</li>
                    <li>{t("admission.place2")}</li>
                    <li>{t("admission.place3")}</li>
                </ul>
            </div>

            {/* Right Section - Image */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <img
                    src={hailmary3}
                    alt="Hail Mary"
                    className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
                />
                <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
                    {t("motherText")}
                </p>
            </div>
        </div>
    );
};

export default OlevelAdmission;
